<template>
  <div class="wg-row com-anm22-app-text-l" style="justify-content:center;">
    <div class="wg-row keypad-container" :style="gridStyle">
      <div
        v-for="(key,index) in layout"
        :key="'keypad-'+index"
        :class="[
          'wg-row',
          'keypad-cell',
          key.disabled ? 'disabled' : ''
        ]"
        :style="getKeyStyle(key)"
        :title="getKeyLabel(key)"
        @click.stop="keyPressed(key)"
      >
        <img v-if="key.icon" class="com-anm22-app-img-fixed-height-l" :style="getKeyImgStyle(key)" :src="key.icon">
        <div class="key-label">{{ getKeyLabel(key) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    inputSelected: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 4
    },
    cols: {
      type: Number,
      default: 5
    },
    layout: {
      type: Array,
      default: () => [
        "7", "8", "9", {key:'-', icon:'dash'}, {key:'payment', icon:'walletBlack'},
        "4", "5", "6", {key:'confirm', icon:'tick'}, {key:'delivery', icon:'shippingTruck'},
        "1", "2", "3", {key:'nfis', icon:'print', label:'PRE', dims:[2,1]}, {key:'fis', icon:'printf', label:'FIS', dims:[2,1]},
        "x", "0", ".",
      ]
    }
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    gridStyle() {
      return {
        'grid-template-columns': 'repeat('+ this.cols +', minmax(0, 1fr))',
        'grid-template-rows': 'repeat('+ this.rows +', 1fr)'
      }
    }
  },
  methods: {
    getKeyStyle(key) {
      if(!key.style) {
        return {
          'grid-row': 'auto / span ' + (key.dims ? key.dims[0] : 1),
          'grid-column': 'auto / span ' + (key.dims ? key.dims[1] : 1),
          backgroundColor: '#fff',
        };
      } else {
        if(!key.style.backgroundColor) {
          key.style.backgroundColor = '#fff';
        }
        return {
          'grid-row': 'auto / span ' + (key.dims ? key.dims[0] : 1),
          'grid-column': 'auto / span ' + (key.dims ? key.dims[1] : 1),
          ...key.style
        };
      }
    },
    getKeyImgStyle(key) {
      return key.imgStyle || {};
    },
    getKeyLabel(key) {
      if(typeof(key) === 'string') {
        return key;
      } else {
        return key.label;
      }
    },
    keyPressed(key) {
      if(!key.disabled) {
        if(key.fn) {
          key.fn();
        } else {
          let cmd = key.key || key;
          this.$emit('keypad-pressed', cmd);
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.keypad-container {
  display: grid;
  border: none;
}

.keypad-cell {
  min-height: 60px;
  height: 100%;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  user-select: none;
  flex-wrap: nowrap;
  transition: background-color 0.4s;
  img {
    height: 30px;
  }
  div {
    font-size: 18px;
  }
  &.disabled {
    transition: none;
    pointer-events: none;
    div, img {
      opacity: 0.3;
    }
  }
  &:active {
    background-color: rgb(10, 171, 244) !important;
    transition: 0s;
  }
}
</style>

